/** Front end JS File **/
"use strict";

var wkwccv = jQuery.noConflict();

document.addEventListener('DOMContentLoaded', function () {
    var guest_user_allowed_email_verification = front_js_script.email_verification_enabled;
    let ajax_url = front_js_script.ajaxurl;
     if ( document.body.classList.contains("woocommerce-checkout") && parseInt(front_js_script.is_user_able_to_checkout ) !== 1 ) {
        var checkoutWrapper = document.querySelector('.wc-block-checkout');
        if (!checkoutWrapper) {
             var checkoutWrapper = document.querySelector('form.woocommerce-checkout');
        }
        if (checkoutWrapper) {
            // Hide the checkout block
            checkoutWrapper.setAttribute("style", "display: none !important;");

            // Create a message element
            var message = document.createElement('div');
            message.className = 'woocommerce-info';

            // Determine the appropriate message
            if (parseInt(front_js_script.is_login) !== 1 ) {
                if (guest_user_allowed_email_verification == 'yes' ) {
                    message.innerHTML = front_js_script.login_message_guest_case + ' <a class="button" href="' + front_js_script.my_account_url + '">'+ front_js_script.login_text + '/' + front_js_script.register_text + '</a>';
                } else {
                    message.innerHTML = front_js_script.login_message + ' <a class="button" href="' + front_js_script.my_account_url + '">'+ front_js_script.login_text + '/' + front_js_script.register_text + '</a>';
                }
            } else if (parseInt(front_js_script.is_user_verified) !== 1) {
                message.innerHTML = front_js_script.verification_message + ' <a class="button" href="' + front_js_script.my_account_url  + '">'+ front_js_script.status_text +'</a>';
            }

            // Create a return to cart element
            var returnToCart = document.createElement('p');
            var cartLink = document.createElement('a');
            cartLink.className = 'button wc-backward';
            cartLink.href = front_js_script.site_url + '/cart';
            cartLink.innerText = front_js_script.return_to_cart;
            returnToCart.appendChild(cartLink);

            // Append message and return to cart link to the checkout wrapper's parent
            checkoutWrapper.parentNode.insertBefore(message, checkoutWrapper);
            checkoutWrapper.parentNode.insertBefore(returnToCart, checkoutWrapper);
        }
    }

    // Attach click event listener to the send verification email button
    document.addEventListener('click', function (event) {
        if (event.target && event.target.id === 'send_verification_email') {
            event.preventDefault();
            displayEmailForm();
        }
    });

    // Function to validate email format
    function isEmailValid(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    // Function to display the email form
    function displayEmailForm() {
        var emailForm = document.getElementById('wkwccv_guest_user_email_verification_form');
        if (emailForm.style.display === 'block') {
            emailForm.style.display = 'none';
        } else {
            emailForm.style.display = 'block';
        }
    }

    // Function to handle sending verification email
    function handleVerificationEmail(event) {
        event.preventDefault();
        var emailInput = document.getElementById('guest_email');
        var email = emailInput.value ? emailInput.value.trim() : '';

        if (!email || !isEmailValid(email)) {
            alert(front_js_script.invalid_mail_message);
            return;
        }

        const params = new URLSearchParams({
            action: 'wkwccv_send_verification_email',
            email: email,
            nonce: front_js_script.send_email_verification_nonce.toString()
        });

        fetch(ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: params
        })
        .then(response => {
            console.log('Response status:', response.status);
            return response.json();
        })
        .then(data => {
            console.log('Response data:', data);
            if (data.success) {
                alert(data.data.message);
                // Optionally, hide the form again after successful email submission
                var emailForm = document.getElementById('wkwccv_guest_user_email_verification_form');
                if (emailForm) {
                    emailForm.style.display = 'none';
                }
            } else {
                alert(data.data.message);
            }
        })
        .catch(error => {
            console.error('Error sending verification email:', error);
            alert(front_js_script.send_mail_message);
        });
    }

    // Attach submit event listener to the email form
    var emailForm = document.getElementById('guest_email_verification_form');
    if (emailForm) {
        emailForm.addEventListener('submit', handleVerificationEmail);
    }
});

// Document ready function for handling file input change
wkwccv(function () {
    wkwccv('input[type=file]').change(function () {
        if (this.files.length > 0) {
            wkwccv(".wkwccv-uploaded-document-name").html(this.files[0].name);
        } else {
            wkwccv(".wkwccv-uploaded-document-name").html(front_js_script.no_file_choosen);
        }
    });

    // Handle document input change (assuming #wkwccv-document exists)
    if (document.querySelector('#wkwccv-document')) {
        document.querySelector('#wkwccv-document').addEventListener('change', function (e) {
            const check_file = validator.escape(e.target.files[0].name);
            document.querySelector('.wkwccv-uploaded-document-name').innerHTML = check_file;
        });
    }
});


document.addEventListener('DOMContentLoaded', function () {
    var document_onfront = jQuery('#_wkwccv_document_visible_onfront' ).val();
    if ( '1' == document_onfront ) {
        const fieldset = document.querySelector( 'wkwccv-dashicons-media-document-duplicate');
        if (fieldset) {
            fieldset.remove(); // Removes the element from the DOM.
            wkwccv('.wkwccv-previous-uploaded-file').hide();
        }

        const fieldsets = document.querySelector('a.wkwc_view_upload');
        if (fieldsets) {
            fieldsets.remove(); // Removes the element from the DOM.
            wkwccv('.wkwccv-previous-uploaded-file').hide();
        }
    }
});
